import { Fragment, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { PrimaryMobile } from "../../buttons/mobile/Primary";
import { Otp } from "../../legal/Otp";
import { Primary } from "../../buttons/Primary";
import { ColombiaIconInput } from "../../inputs/CoIombiaIconInput";
import { DefaultInput } from "../../inputs/DefaultInput";
import { PersonalData } from "./PersonalData"; 

export function VerifyCellphone() {
  const [open, setOpen] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");
  const [showError, setShowError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [showViewVerifyOtp, setShowViewVerifyOtp] = useState(false);
  const [showSuccessView, setShowSuccessView] = useState(false);
  const [otpInput, setOptInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
    setPhoneInput(value);
  };

  const handleClosePanel = () => {
    setOpen(false);
    setPhoneInput("");
    setMessageError("");
    setShowViewVerifyOtp(false);
    setShowError(false);
  };

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-end">
            <PrimaryMobile
              /* text={"Enviar invitación"} */
              icon={<ArrowRightIcon className="w-6 h-auto" />}
            />
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={handleClosePanel} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-transparent bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClosePanel}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-white font-bold text-xl">
                          Verificación de seguridad
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white p-4">
                    <div className="text-grayP py-4">
                      Digita el código de 6 dígitos que hemos enviado a tu
                      celular {"********02"} .
                    </div>
                    <div className="text-center block">
                      <Otp
                        name="tokensms"
                        id="tokensms"
                      />
                    </div>

                    <div className="grid justify-items-end pt-8">
                      <div className="grid content-center">
                        <PersonalData />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
